










































import { Vue, Component, Prop } from "vue-property-decorator";
import SocialLinks from "@/components/SocialLinks.vue";
import FooterMenuItem from "@/components/FooterMenuItem.vue";



@Component({
  components: {
    SocialLinks,
    FooterMenuItem,
  },
})
export default class FooterWeShope extends Vue {
}
